import { ChevronSmallDownIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiAccordionOverrides = {
  MuiAccordion: {
    defaultProps: {
      disableGutters: true,
      square: true
    },
    styleOverrides: {
      root: ({
        theme,
        ownerState
      }) => ({
        boxShadow: 'none',
        ':before': {
          display: 'none'
        },
        '&.MuiAccordionRoot': {
          borderBottom: ownerState.expanded ? undefined : `1px solid ${theme.palette.divider}`
        }
      })
    }
  },
  MuiAccordionSummary: {
    defaultProps: {
      expandIcon: /*#__PURE__*/jsx(ChevronSmallDownIcon, {})
    },
    styleOverrides: {
      root: ({
        theme
      }) => ({
        minHeight: 'auto',
        '.MuiAccordionRoot > .MuiAccordion-heading > &': {
          backgroundColor: theme.palette.gray10
        }
      })
    }
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        backgroundColor: theme.palette.white
      })
    }
  }
};

export { MuiAccordionOverrides };
